import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { zodSnakeCaseString } from '@/shared/lib';
import type { OntologyFormValues } from './types';

const createSchema = (t: TFunction<readonly ['ontology', 'common']>) => {
  return z.object({
    code: zodSnakeCaseString({
      message: t('ontology:codeMustBeSnakeCase'),
      minLength: 1,
      maxLength: 100,
    }),
    name: z
      .string({ error: t('common:required') })
      .min(1, t('common:required'))
      .max(255, t('common:maxLength', { count: 255 })),
    description: z.string(),
  }) satisfies z.ZodType<OntologyFormValues>;
};

/**
 * Zod-схема формы типа сущности онтологии.
 */
export const useOntologyTypeSchema = () => {
  const { t } = useTranslation(['ontology', 'common']);

  return createSchema(t);
};
